import { useQueryControl } from '@bonusly/url';

export const useEvaluationId = () => {
	const { query, onChange } = useQueryControl('evaluation_id');

	return {
		evaluationId: query,
		clearId: () => onChange(''),
		updateSelectedEvaluationId: (id: string) => onChange(id),
	};
};
